import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { type User } from 'types/swagger';

interface UserSessionState {
  user: User | null;
  isLoggingIn: boolean;
}

const initialState: UserSessionState = {
  user: null,
  isLoggingIn: !!localStorage.getItem('access'),
};

export const userSessionSlice = createSlice({
  name: 'userSession',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User | null>) => {
      state.user = action.payload;
    },
    setIsLoggingIn: (state, action: PayloadAction<boolean>) => {
      state.isLoggingIn = action.payload;
    },
  },
});

export const { setUser, setIsLoggingIn } = userSessionSlice.actions;

export default userSessionSlice.reducer;
